import ButtonRectangle from "./ButtonRectangle";
import usePokemonData from "../utils/usePokemonData";
import DetailsMesuresCard from "./DetailsMesuresCard";

export const PokemonCard = ({
  pokename,
  typeEl,
  pokeURL,
  mostrar,
  setMainDetailsURL,
  setIdMain,
}) => {
  const individualDataPokemon =
    usePokemonData(pokeURL); /* objeto de cada pokemon */
  const isLoading =
    !individualDataPokemon ||
    !individualDataPokemon.sprites ||
    !individualDataPokemon.sprites.versions?.["generation-v"]?.["black-white"]
      ?.front_default;

  if (isLoading) {
    return (
      <div className="skeleton-card">
        <div className="skeleton-image"></div>
        <div className="skeleton-text"></div>
      </div>
    );
  }

  const typesEachPokemon = individualDataPokemon.types.map((t) => t.type.name); //["fire", "flying", cada de lo que sea]

  if (
    typeEl &&
    !typesEachPokemon.map((t) => t.toLowerCase()).includes(typeEl.toLowerCase())
  ) {
    return null;
  }
  if (typeEl && !typesEachPokemon.includes(typeEl)) return null;
  return (
    <div className="pokemonCard">
      {console.log(individualDataPokemon)}
      <div className="pokeImagen-main-card">
        <img
          className="single-pokemon-card"
          src={
            individualDataPokemon?.sprites?.versions?.["generation-v"]?.[
              "black-white"
            ]?.front_default || "fallback-image.png"
          }
          alt={"alt"}
          title={"title"}
        />
      </div>
      <div className="informacion-pokemon">
        <div>
          <h1 className="poke-name">{pokename.toUpperCase()}</h1>
        </div>
        <div className="abilities-items">
          {/* se renderiza dinamicamente */}
          {individualDataPokemon?.types.map((type, index) => (
            <button className="element-card">{type.type.name}</button>
          ))}
        </div>
        <div>
          <DetailsMesuresCard
            heightPokemon={individualDataPokemon?.height}
            weigthPokemon={individualDataPokemon?.weight}
          />
        </div>
        <ButtonRectangle
          pokemonName={pokename}
          setMainDetailsURL={setMainDetailsURL}
          setIdMain={setIdMain}
          individualDataPokemon={individualDataPokemon}
          onClickEvent={mostrar}
          colorButton={"green"}
          complementaryText="⚡︎ Details"
        />
      </div>
    </div>
  );
};

/* Este componente es de la carta individual del pokemon en el grid de 4 x4  */
